import { hasNonZeroBounds } from '../../common/helpers/get-element-with-visible-box';

const getCurrentElement = (elementsList) => {
  const currentItem = [...elementsList].reverse().find(({ element }) => hasNonZeroBounds(element));

  return (currentItem || elementsList[elementsList.length - 1]).element;
};

export default getCurrentElement;
